import React, { useState } from "react";
import CCrud from "components/Molecules/Crud";
// import { initialValues, validationSchema } from "./structure";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, Stack } from "@mui/material";
import Breadcrumb from "components/Atoms/SharedComponents/Breadcrumbs/Breadcrumb";
import AddIcon from "@mui/icons-material/Add";
import { useEffect } from "react";
import OrderDetailsTemplate from "./details";
import OrderDetailsPage from "pages/orders/ordersDetails.page";
import { useTranslation } from "react-i18next";
import { StoreUser } from "services/modules/utils/constant";

const OrdersTemplate = ({
  handlePageChange,
  data,
  details,
  count,
  handelSubmit,
  deleteFun,
  filterList,
  actionsList,
  breadcrumbs,
  setFilterObj,
  rowData,
  paginationPage,
  headerChildren,
  modalComponents,
  openDeleteModal,
  setOpenDeleteModal,
  handleDeleteRequest,
  selectedRow,
  handleOrderCancel,
  isStore,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  let [searchParams] = useSearchParams();
  const id = searchParams.get("id");

  const [supportedLang, setSupportedLang] = useState("en");

  const [isClickable, setIsClickable] = useState(false);

  useEffect(() => {
    setIsClickable(selectedRow?.formikData?.values?.need_action);
  }, [selectedRow?.formikData?.values?.need_action]);

  let columnData = [
    { accessor: "id", Header: t("products.col_id") },
    { accessor: "order_number", Header: t("orders.col_order_number") },
    {
      accessor: "total",
      Header: t("orders.col_total"),
      sort: true,
    },
    {
      accessor: "payment_method.name",
      Header: t("orders.col_payment_method"),
    },
    { accessor: "date", Header: t("orders.col_date"), sort: true },
    {
      accessor: "status",
      Header: t("orders.col_status"),
    },
    { accessor: "Actions", Header: t("products.col_actions") },
  ];
  if (isStore) {
    columnData?.splice(3, 1);
  }
  return (
    <>
      <Box>
        <Stack
          direction="row"
          alignSelf="start"
          justifyContent="start"
          gap={2}
          width="100%"
          // mb={1}
        >
          <Breadcrumb data={breadcrumbs} />
        </Stack>
        <CCrud
          table={{
            list: data,
            listTitle: t("orders.list_title"),
            createBtnTitle: "",
            CreateBtnIcon: AddIcon,
            createBtnFun: () => navigate("?type=form"),
            columns: columnData,
            isSearch: false,
            searchInputPlaceholder: "",
            isChecked: false,
            total_count: count,
            setFilterObj,
            className: "organization-table system-configurations-table",
            paginationPage: paginationPage,
            handlePageChange,
            rowData: rowData,
            filterList,
            className: "main-table",
            actionsList, //if you want to add custom actions list
            headerChildren,
            details,
            openDeleteModal,
            setOpenDeleteModal,
            handleDeleteRequest,
          }}
          form={{
            // initialValues: !id
            //   ? { is_visible: false, need_action: false }
            //   : initialValues(details, supportedLang),
            // structure: () => structure(supportedLang, isClickable),
            // validationSchema: validationSchema,
            deleteFun: deleteFun,
            title: id ? "Edit Featured Ad" : "Add Featured Ad",
            submitTitle: id ? "Update" : "Add",
            onSubmit: handelSubmit,
            className: { form: "main-form", actionButton: "main-form-buttons" },
          }}
          DetailsComponent={
            <OrderDetailsPage
              details={details}
              handleOrderCancel={handleOrderCancel}
            />
          } //to send details component diff from the default
          modalComponents={modalComponents}
        />
      </Box>
    </>
  );
};

export default OrdersTemplate;
